import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_AdvisorWizardManager = 'Advisor Wizard Manager';
export const AdvisorWizardManagerPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_AdvisorWizardManager, defaultUIAccessLevels);
//# sourceMappingURL=advisor-wizard-manager.js.map